// InteractionDots — the rounded-square ("squircle") interaction tokens.
// 3 states: open (outline, not earned), green (earned, unspent), black (spent).
// Within a task row, earned dots sit on the LEFT; spent (black) fill from the
// right edge of the earned group leftward — "right to left" as questions burn.
import { motion } from "framer-motion";

const STATE_CLS = {
  black: "bg-[#1C1B1A] border-[#1C1B1A]",
  green: "bg-[#3F7A4E] border-[#3F7A4E] shadow-[0_0_0_1px_rgba(63,122,78,0.25)]",
  open: "bg-transparent border-[#C9C7C2]",
};

function dotStateAt(i, { green, black }) {
  if (i < green) return "green";
  if (i < green + black) return "black";
  return "open";
}

export function DotRow({ total, green = 0, black = 0, size = 14 }) {
  const dots = [];
  for (let i = 0; i < total; i++) dots.push(dotStateAt(i, { green, black }));
  return (
    <div className="flex items-center gap-1.5 flex-wrap" aria-hidden="true">
      {dots.map((s, i) => (
        <motion.span
          key={i}
          initial={false}
          animate={{ scale: s === "green" ? [1, 1.18, 1] : 1 }}
          transition={{ duration: 0.28 }}
          className={`inline-block rounded-[5px] border-2 transition-colors duration-300 ${STATE_CLS[s]}`}
          style={{ width: size, height: size }}
          data-testid={`dot-${s}`}
        />
      ))}
    </div>
  );
}

// One task line: dots + label + (optional) action affordance.
export function TaskRow({ task }) {
  const done = task.earned >= task.total && task.green === 0 && task.open === 0;
  return (
    <div className="flex items-start gap-3 py-1.5" data-testid={`unlock-task-${task.key}`}>
      <div className="pt-0.5 shrink-0">
        <DotRow total={task.total} green={task.green} black={task.black} />
      </div>
      <div className="min-w-0">
        <p className={`text-[12px] leading-snug ${done ? "text-[#9A9892] line-through" : "text-[#1C1B1A]"}`}>
          {task.label}
        </p>
      </div>
    </div>
  );
}
